module.exports = __webpack_public_path__ + "static/media/cicon.3500539b.svg";